module.exports = __webpack_public_path__ + "img/trinity_parses_pdfs_2b_crop.fc7504a6.png";